(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/race-tips.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/race-tips.js');

'use strict';

const {
  useEffect,
  useState,
  useRef
} = React;
const {
  fetchTips
} = svs.racing.raceService;
const {
  ImageTypes,
  getImageOptions
} = svs.racing.common.imageOptions;
const {
  ReactIcon,
  ReactIconButton,
  ReactButton
} = svs.ui;
const {
  Image
} = svs.content.image_v2;
const isDesktop = svs.core.detect.formfactor.desktop();
const logger = svs.core.log.getLogger('racing.play.tips');
const RaceTips = _ref => {
  let {
    race
  } = _ref;
  const [tips, setTips] = useState();
  const [isClosed, setIsClosed] = useState(true);
  const [showToggle, setShowToggle] = useState(true);
  const tipsHolder = useRef();
  useEffect(() => {
    fetchTips(race.raceId, (err, response) => {
      if (err) {
        logger.info("fetch-tips-error: ".concat(err.error));
        setTips(undefined);
      } else {
        const tipsResponse = response || {};
        setTips(tipsResponse);
      }
    });
  }, [race.raceId]);
  const toggleRanking = () => {
    if (isClosed) {
      setIsClosed(false);
    } else {
      setIsClosed(true);
    }
  };
  const getTipsHeightOnResize = () => {
    if (tipsHolder.current) {
      tipsHolder.current.classList.remove('race-tips-closed');
      if (tipsHolder.current.offsetHeight > 80) {
        setShowToggle(true);
        tipsHolder.current.classList.add('race-tips-closed');
      } else {
        setShowToggle(false);
      }
    }
  };
  useEffect(() => {
    if (tips) {
      if (isDesktop) {
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            getTipsHeightOnResize();
          }, 250);
        });
      }
      getTipsHeightOnResize();
    }
  }, [tips]);
  const handleHelpButtonClick = e => {
    svs.components.dialog.api.add(new svs.components.dialog.Contextual({
      area: svs.components.dialog.area.CONTEXTUAL,
      branding: svs.components.dialog.branding.SPORT,
      type: svs.components.dialog.type.INFO,
      attachTo: e.currentTarget,
      title: '',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'Equidia är ett franskt produktionsbolag som levererar streaming, prognoser, spelanalyser och annat innehåll till franskt trav och galopp.',
        align: svs.components.dialog.message.align.CENTER
      }]
    }));
  };
  const findSilk = tip => {
    const participant = race.participants.filter(participant => participant.participantNumber === tip.participantsNumber);
    return participant && participant[0].silks && participant[0].silks;
  };
  if (tips) {
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "race-tips-header"
    }, React.createElement("div", {
      className: "race-tips-header-text"
    }, "Ta hj\xE4lp av Equidias ranking av h\xE4starna"), React.createElement("div", {
      className: "race-tips-header-help"
    }, React.createElement(ReactIconButton, {
      className: "align-bottom icon-button padding-xs-h",
      onClick: e => handleHelpButtonClick(e),
      type: "button"
    }, React.createElement(ReactIcon, {
      color: "fc-sport",
      icon: "help",
      size: "300"
    })))), React.createElement("div", {
      className: "race-tips-holder".concat(isClosed ? ' race-tips-closed' : ''),
      ref: tipsHolder
    }, tips.map(tip => {
      const imageOptions = race.meeting.silksFormattedDate && getImageOptions(findSilk(tip), race.meeting.silksFormattedDate, ImageTypes.TipsSilk);
      return React.createElement("div", {
        className: "race-tip",
        key: tip.rankOrder
      }, React.createElement("div", {
        className: "race-tip-rank"
      }, tip.rankOrder), React.createElement("div", {
        className: "race-tip-participant"
      }, isDesktop && race && tip && race.meeting.silksFormattedDate && React.createElement("div", {
        className: "race-tip-participant-silk"
      }, React.createElement(Image, {
        image: imageOptions
      })), React.createElement("div", {
        className: "race-tip-participant-number"
      }, tip.participantsNumber)));
    })), showToggle && React.createElement("div", {
      className: "race-tips-toggle"
    }, React.createElement(ReactButton, {
      className: "icon-button race-tips-toggle-button padding-h-1",
      iconPosition: "right",
      onClick: () => toggleRanking(),
      size: 100,
      thin: true,
      transparent: true,
      type: "button"
    }, React.createElement(ReactIcon, {
      color: "fc-racing",
      icon: isClosed ? 'plus' : 'minus',
      size: "100"
    }), isClosed ? 'Visa fler hästar' : 'Visa färre hästar')));
  }
  return null;
};
svs.racing_game.components.play.RaceTips = React.memo(RaceTips);

 })(window);